import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createSuper";
import { ValueWithRandom } from "../../ValueWithRandom";
export var BounceFactor = /*#__PURE__*/function (_ValueWithRandom) {
  _inherits(BounceFactor, _ValueWithRandom);
  var _super = _createSuper(BounceFactor);
  function BounceFactor() {
    var _this;
    _classCallCheck(this, BounceFactor);
    _this = _super.call(this);
    _this.random.minimumValue = 0.1;
    _this.value = 1;
    return _this;
  }
  return _createClass(BounceFactor);
}(ValueWithRandom);